var React = require('react');

function Link (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#e6e6e6","d":"M16 96h400v400H16z","key":0}),React.createElement("path",{"d":"M325 96l-77-80h248v248l-80-77-181 181-91-91z","fill":"#3498db","key":1})]);
}

Link.defaultProps = {"viewBox":"0 0 512 512"};

module.exports = Link;

Link.default = Link;
